import { render } from "./Archive-page.vue?vue&type=template&id=2ea93078&scoped=true"
import script from "./Archive-page.vue?vue&type=script&lang=js"
export * from "./Archive-page.vue?vue&type=script&lang=js"

import "./Archive-page.vue?vue&type=style&index=0&id=2ea93078&scoped=true&lang=css"

import exportComponent from "/root/fixed-links/crm-updated/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea93078"]])

export default __exports__